<template>
  <AccessStateLayout :description="description" eyebrow="Whoops!" test-id="invalid-session-state" :title="title" />
</template>

<script setup lang="ts">
import { computed } from 'vue';
import AccessStateLayout from './AccessStateLayout.vue';

const props = defineProps<{
  reason?: string;
}>();

const isExpiredToken = computed(() => props.reason === 'expired');
const title = computed(() => (isExpiredToken.value ? 'This session link has expired' : 'This session link is not valid'));
const description = computed(() =>
  isExpiredToken.value
    ? 'Your invite link has expired. Please request a new session link and try again.'
    : "The session you are trying to join doesn't exist. Please try again, or contact us for assistance.",
);
</script>
